import Phaser from 'phaser';

import { Colors } from '../consts/Colors';
import { tags } from '../consts/Tags';

export default class BlueMessageBox extends Phaser.GameObjects.Container {
    constructor(scene, x, y, text, maxWidth = 600, ratio = 1) {
        super(scene, x, y);

        const paddingX = 0 * ratio;
        const paddingY = 16 * ratio;

        // === TEXTE TAGUÉ ===
        const label = scene.add
            .rexBBCodeText(0, 0, text, {
                fontFamily: 'MonteserratMedium',
                fontSize: `${24 * ratio}px`,
                color: '#ffffff',
                wrap: {
                    mode: 'word',
                    width: maxWidth - paddingX * 2,
                },
                halign: 'center',
                tags: tags,
                backgroundColor: 'transparent',
                lineSpacing: 2 * ratio,
            })
            .setOrigin(0.5);

        const bounds = label.getBounds();
        const backgroundWidth = bounds.width * 1.5 + paddingX * 2;
        const backgroundHeight = bounds.height + paddingY * 2;

        const bgShadow = scene.add
            .rexRoundRectangle(5, 3, backgroundWidth, backgroundHeight, 16, 0x000000, 0.5)
            .setOrigin(0.5);

        const bg = scene.add
            .rexRoundRectangle(0, 0, backgroundWidth, backgroundHeight, 16, Colors.Elmt.BleuNovotel)
            .setOrigin(0.5);

        this.add([bgShadow, bg, label]);
        scene.add.existing(this);
    }
}
